import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../store/types';

export const selectCourseUserProfilesById = (state: RootState) => state.db.userProfiles.byId;

export const selectCourseUserProfile = createSelector(
  [selectCourseUserProfilesById, (state: RootState, id: MongoId) => id],
  (courseUserProfilesById, id) => {
    return courseUserProfilesById[id];
  }
);
